module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4g5Qo"))).then(() => parcelRequire('1iHdE'));